'use strict';

export default function Switch({title, count = undefined, disabled = false, checked = false, onChange}) {

    const inputId = React.useId()

    const handleChange = (value) => {
        onChange && onChange(value)
    }

    return <div className="el__filter">
        <div className="el__filter-content">
            <div className={cn("checkbox", disabled && "disabled")}>
                <input id={inputId}
                       type="checkbox"
                       checked={checked}
                       disabled={disabled}
                       onChange={(event) => handleChange(event.target.checked)}
                />
                <label htmlFor={inputId}>
                    <span></span>
                </label>
                <span>{title} {count !== undefined && <b>{`(${count})`}</b>}</span>
            </div>
        </div>
    </div>
}